<template>
    <div>
        <div  class="container-fluid mb-5">

            <div class="white-bg mb-3 mt-4 d-flex justify-content-between">
                <div class="">
                    <h4 class="headings">Property Informations</h4>
                    <h6 class="subheadings d-none d-sm-block">Here are all the details of this property, click button to edit or update details </h6>
                </div>
                <!-- <div>
                    <button class="btn greyButton">Edit details</button>
                </div> -->
            </div>
            <div v-if="loading">
                <PageLoader></PageLoader>
            </div>

            <div class="property-details white-bg">
                <h5 class="headings">Property details</h5>

                <div class="row">
                    <div class="col-md-4">
                        <div class="details-item">
                            <h6>Property ID</h6>
                            <h5>{{ propertyDetails.batch }}</h5>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="details-item">
                            <h6>Property plane type</h6>
                            <!-- <h5>{{propertyDetails.plan_type}}</h5> -->
                            <h5>---</h5>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="details-item">
                            <h6>Property plane type expiration date</h6>
                            <h5>---</h5>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="details-item">
                            <h6>Property type</h6>
                            <h5>{{ propertyDetails.typename }}</h5>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="details-item">
                            <h6>Property subtype</h6>
                            <h5>{{propertyDetails.subtypename}}</h5>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="details-item">
                            <h6>Total rent value</h6>
                            <h5>{{ Number(outterDetails.rent_value).toLocaleString() }}</h5>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="details-item">
                            <h6>Total number of tenant </h6>
                            <h5>{{ outterDetails.number_of_tenant }}</h5>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="details-item">
                            <h6>Address </h6>
                            <h5>{{propertyDetails.address}}</h5>
                        </div>
                    </div>
                    <div class="col-md-4" v-if="propertyDetails.facility_manager != null">
                        <div class="details-item">
                            <h6>Assigned FMC</h6>
                            <h5>{{ propertyDetails.facility_manager.firstname }} {{ propertyDetails.facility_manager.lastname }}</h5>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="details-item">
                            <h6>Property lawyer</h6>
                            <h5>---</h5>
                        </div>
                    </div>
                </div>

            </div>

            <div class="white-bg mb-4">
                <h5 class="headings">Unit Tenant Info</h5>

                <div class="mb-3 col-md-4 pl-0">
                    <input type="text" v-model="search" class="form-control" placeholder="Search by name, unit number">
                </div>

                <div class="table-responsive tableList">
                    <!-- <table class="table" v-if="!loadingDashboard && assingedFMArray.length != 0"> -->
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">Unit</th>
                                <th scope="col">Tenant Name</th>
                                <th scope="col">Payment Type</th>
                                <th scope="col">Rent Due Date</th>
                                <th scope="col">Satus</th>
                                <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- v-for="(item, index) in landlords"
                                :key="index" -->
                            <tr v-for="(item, index) in filteredTenant"
                                :key="index">
                                <td>{{ item.unit }}</td>
                                <td>{{ item.tenant.firstname }} {{ item.tenant.firstname }}</td>
                                <td>{{item.payment_type == 'R' ? 'Regularised' : '', item.payment_type == 'H' ? 'Harmonized' : '', item.payment_type == 'G' ? 'Guaranteed' : '', }}</td>
                                <td>{{ item.due_date | moment2 }}</td>
                                <!-- <td class="occupied credit"><span>Occupied</span></td> -->
                                <td style="color: #0033EA">
                                    View more
                                </td>
                                <!-- <td></td> -->
                                <!-- <span :class="[data.type == 'credit' ? 'credit' : 'debit']" class=""></span> -->
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="filteredTenant.length == 0" class="empty-state mt-5 mb-5">
                            <img src="../assets/icons/emptycan-state.svg" alt="empty">
                            <h5>No available data</h5>
                        </div>
                    <!-- <div v-if="landlords.length == 0 && !loadingLandlord">
                        <EmptyState :emptyData="emptyDataObject2" />
                    </div> -->
                </div>
            </div>

            <div class="white-bg mb-4">
                <div>
                    <h5 class="headings">Property personnels</h5>
                    <h6 class="subheadings">Here are all the personnels on this property</h6>
                </div>
                <div class="table-responsive tableList">
                    <!-- <table class="table" v-if="!loadingDashboard && assingedFMArray.length != 0"> -->
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">Personnel Type</th>
                                <th scope="col">Name</th>
                                <th scope="col">Company</th>
                                <th scope="col">Phone Number</th>
                                <th scope="col">Email</th>
                                <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- v-for="(item, index) in tenantsdetails"
                                :key="index" -->
                            <tr>
                                <td>Lawyer</td>
                                <td>Ajax call JSON</td>
                                <td>BBD Law firm</td>
                                <td>08083746234</td>
                                <td><span>ajaxcall@gmail.com</span></td>
                                <td style="color: #0033EA">
                                    View
                                </td>
                                <!-- <td></td> -->
                                <!-- <span :class="[data.type == 'credit' ? 'credit' : 'debit']" class=""></span> -->
                            </tr>   

                            <tr>
                                <td>Lawyer</td>
                                <td>Ajax call JSON</td>
                                <td>BBD Law firm</td>
                                <td>08083746234</td>
                                <td><span>ajaxcall@gmail.com</span></td>
                                <td style="color: #0033EA">
                                    View
                                </td>
                                <!-- <td></td> -->
                                <!-- <span :class="[data.type == 'credit' ? 'credit' : 'debit']" class=""></span> -->
                            </tr> 
                            <tr>
                                <td>Lawyer</td>
                                <td>Ajax call JSON</td>
                                <td>BBD Law firm</td>
                                <td>08083746234</td>
                                <td><span>ajaxcall@gmail.com</span></td>
                                <td style="color: #0033EA">
                                    View
                                </td>
                                <!-- <td></td> -->
                                <!-- <span :class="[data.type == 'credit' ? 'credit' : 'debit']" class=""></span> -->
                            </tr> 
                    
                        </tbody>
                    </table>
                    <!-- <div v-if="landlords.length == 0 && !loadingLandlord">
                        <EmptyState :emptyData="emptyDataObject2" />
                    </div> -->
                </div>
            </div>

            <div class="white-bg mb-4">
                <div>
                    <h5 class="headings">Rent payment history</h5>
                </div>

                <div class="payment-history">
                    <div class="row">
                        <div class="col-md-6" v-for="(item, index) in rentDisbursment"
                                :key="index">
                            <div class="history-holder">
                                <h4>Unit {{ item.unit_name }}</h4>
                                <h5>Paid amount: ₦{{Number(item.amount).toLocaleString()}}</h5>
                                <h5>Tenant name: {{item.user.firstname}} {{ item.user.lasttname }}</h5>
                                <div class="text-right">
                                    <small>
                                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.50975 2.02344C4.21428 2.02344 1.5332 4.70452 1.5332 7.99998C1.5332 11.2954 4.21428 13.9765 7.50975 13.9765C10.8052 13.9765 13.4863 11.2954 13.4863 7.99998C13.4863 4.70452 10.8052 2.02344 7.50975 2.02344ZM7.50975 12.7812C4.87349 12.7812 2.72851 10.6362 2.72851 7.99998C2.72851 5.36373 4.87349 3.21875 7.50975 3.21875C10.146 3.21875 12.291 5.36373 12.291 7.99998C12.291 10.6362 10.146 12.7812 7.50975 12.7812Z" fill="#374151"/>
                                            <path d="M8.10742 5.01172H6.91211V8.59764H10.498V7.40234H8.10742V5.01172Z" fill="#374151"/>
                                        </svg>
                                         {{item.date | moment3}}
                                    </small> 
                                    <small>
                                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.60156 7.40234H5.79687V8.59765H4.60156V7.40234ZM4.60156 9.79296H5.79687V10.9883H4.60156V9.79296ZM6.99218 7.40234H8.18749V8.59765H6.99218V7.40234ZM6.99218 9.79296H8.18749V10.9883H6.99218V9.79296ZM9.3828 7.40234H10.5781V8.59765H9.3828V7.40234ZM9.3828 9.79296H10.5781V10.9883H9.3828V9.79296Z" fill="#374151"/>
                                            <path d="M3.40625 13.9765H11.7734C12.4326 13.9765 12.9687 13.4404 12.9687 12.7812V4.41406C12.9687 3.75484 12.4326 3.21875 11.7734 3.21875H10.5781V2.02344H9.38279V3.21875H5.79686V2.02344H4.60156V3.21875H3.40625C2.74703 3.21875 2.21094 3.75484 2.21094 4.41406V12.7812C2.21094 13.4404 2.74703 13.9765 3.40625 13.9765ZM11.7734 5.60936L11.774 12.7812H3.40625V5.60936H11.7734Z" fill="#374151"/>
                                        </svg>

                                        {{item.date | moment2}}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



<script>
import '@/assets/styles/custom.scss';
import PageLoader from "./PageLoader.vue";
import { Service } from "../store/service";
const Api = new Service();
import moment from "moment";

export default {
    name: "LandlordProperties2",
    components: {
        PageLoader
    },
    data() {
        return {
            loading: false,
            batchNum: this.$route.params.id,
            propertyDetails: [],
            personnels: [],
            rentDisbursment: [],
            tenantsdetails: [],
            outterDetails: {},
            search: "",
        }
    },
    watch: {
        '$route.params.id'(routeId) {
            this.batchNum = routeId
        }
    },
    computed: {
        filteredTenant() {
            return this.tenantsdetails.filter((item) =>
                item.tenant.firstname.toLowerCase().includes(this.search.toLowerCase()) ||
                item.tenant.lastname.toLowerCase().includes(this.search.toLowerCase()) ||
                item.unit.toLowerCase().includes(this.search.toLowerCase())
            );
        },
    },
    mounted() {
        this.fetchPropertyDetails();
    },
    methods: {
        async fetchPropertyDetails() {
            this.loading = true;
        // this.loader = true;
        try {
            await Api.getRequest(`new-dashboard-property-details/${this.batchNum}`)
            .then(res => {
                // if (res.data.error) {
                //   this.hideDiv = false;
                // }
                this.loading = false;
                // console.log("Property deatils", res);
                if (res.data.success) {
                this.tenantsdetails = res.data.tenants;
                this.rentDisbursment =  res.data.rent_disbursment;
                this.propertyDetails = res.data.property[0];
                this.outterDetails = res.data;
                }
            })
            .catch(err => {
                // console.log(err);
                this.loading = false;
                // this.loader = false;
            });
            } finally {
                // console.log("Closed connection");
            }
        },
    },
    filters: {
        moment: function(date) {
            return moment(date).format("MMMM Do YYYY, h:mm:ss a");
        },
        moment2: function(date) {
            return moment(date).format("MMMM Do YYYY");
        },
        moment3: function(date) {
            return moment(date).format("h:mm:ss a");
        }
    }
}
</script>



<style lang="scss" scoped>
    
.property-details {
    .col-md-4 {
        border-bottom: 1px solid #E5E7EB;
    }
    .col-md-4:last-child {
        border-bottom: none;
    }
    margin-bottom: 30px;
}
.details-item {
    h6 {
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        line-height: 40px;
        color: #333333;
        text-align: left;
        margin-bottom: 0;
    }
    h5 {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 25px;
        color: #555C74;
        text-align: left;
    }
}

.payment-history {
    .history-holder {
        background: #FAFAFA;
        border-radius: 4px;
        padding: 12px;
        margin-bottom: 15px;
        h4 {
            font-family: Lato;
            font-weight: 600;
            font-size: 16px;
            line-height: 125%;;
            color: #2B3352;
            text-align: left;
        }
        h5 {
            font-family: Lato;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #555C74;
            text-align: left;
        }
        small {
            font-family: Lato;
            font-weight: 400;
            font-size: 10.04px;
            line-height: 17.21px;
            color: #4B5563;
        }
    }
    
}
// @media screen and (max-width: 599px) {
//     .tenant-button-section {
//         display: block;
//         .sheltaBtn {
//             width: 100%;
//         }
//     }
// }
</style>